<script>
  import { onMount } from "svelte";
  import { navigate } from "svelte-routing";

  onMount(() => navigate("/config/menu", { replace: true }));
</script>
